import { formatPriceWithCurrency } from '@/utils/format-price';

import { OrderBlockWrapper } from '../../../Common/OrderBlockWrapper';

import { OrderTotalProps } from './types';

import styles from './OrderTotal.module.scss';

export const OrderTotal = ({ total, title }: OrderTotalProps) => (
  <OrderBlockWrapper data-testid="gafe-order-total">
    <div className={styles.wrapper}>
      <div className={styles.label} data-testid="gafe-order-total-title">
        {title}
      </div>
      <div className={styles.label} data-testid="gafe-order-total-price">
        {formatPriceWithCurrency(total)}
      </div>
    </div>
    <div className={styles.subtitle}>(Taxes calculated at shipping)</div>
  </OrderBlockWrapper>
);
